import React from "react";
import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import RunsheetIcon from "../../Icons/RunsheetIcon";
const ReturnBranchListComponent = loadable(
  () => import("../../components/ReturnBranch/ReturnBranchList")
);
const ReturnBranchList = () => {
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <RunsheetIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>RTV Branch</span>
      </div>
      <ReturnBranchListComponent />
    </>
  );
};

export default ReturnBranchList;
